<sgt-autocomplete
  [selectedItem]="{
    id: selectedClientePessoa?.id,
    label: selectedClientePessoa?.nome
  }"
  [settings]="settings"
  (changed)="onSearchClientePessoa($event)"
>
  <ng-container item *ngIf="clientesPessoa && clientesPessoa.length">
    <li
      *ngFor="let clientePessoa of clientesPessoa"
      class="autocomplete__item"
      (click)="onSelectClientePessoa(clientePessoa)"
    >
      <div class="d-flex flex-column">
        <span>
          {{ clientePessoa?.codigoIntegracaoErp }} - {{ clientePessoa?.nome }}
        </span>
        <small>
          {{ clientePessoa?.nomeFantasia }} - {{ clientePessoa?.cnpjCpf }}
        </small>
        <small *ngIf="clientePessoa?.nomeCidade">
          {{ clientePessoa?.nomeCidade }} - {{ clientePessoa?.uf }}
        </small>
      </div>

      <div class="badge-container">
        <span
          [style.color]="clientePessoa.cssClassCadastro"
          [ngClass]="clientePessoa.cssClassCadastro">
          {{ clientePessoa.cadastroLabel }}
        </span>

        <span
          [style.color]="clientePessoa.cssClassSituacao"
          [ngClass]="clientePessoa.cssClassSituacao">
          {{ clientePessoa.situacaoLabel }}
        </span>
      </div>
    </li>
  </ng-container>

  <div class="mt-2" info *ngIf="selectedClientePessoa">
    <div class="form-text text-muted d-flex justify-content-between">
      <div class="d-flex flex-column">
        <span>
          <strong>Código Integração ERP:</strong> {{ selectedClientePessoa?.codigoIntegracaoErp }}</span>
        <span>
          <strong>Nome Fantasia:</strong> {{ selectedClientePessoa?.nomeFantasia }}
        </span>
        <span>
          <strong>Localização:</strong>
          <span>
            {{ selectedClientePessoa?.nomeCidade }} - {{ selectedClientePessoa?.uf }}
          </span>
        </span>
        <span>
          <strong>CNPJ/CPF:</strong> {{ selectedClientePessoa?.cnpjCpf }}
        </span>
      </div>

      <div class="d-flex flex-column">
        <span
          [style.color]="selectedClientePessoa.cssClassCadastro"
          [ngClass]="selectedClientePessoa.cssClassCadastro">
          {{ selectedClientePessoa.cadastroLabel }}
        </span>
        <span
          class="mt-1"
          [style.color]="selectedClientePessoa.cssClassSituacao"
          [ngClass]="selectedClientePessoa.cssClassSituacao">
          {{ selectedClientePessoa.situacaoLabel }}
        </span>
      </div>
    </div>
  </div>
</sgt-autocomplete>
